import React from 'react'
import { MultiValue } from 'react-select'
import Select from 'react-select'

import { Station } from '../../../core/stations'
import { preMakingContent } from './pre-making-content'
import styles from '../../styles/modules/pre-making/station-selector.module.scss'

interface SelectOption {
  value: string
  label: string
}

interface Props {
  stations: Station[]
  selectedStation: SelectOption | null
  onStationChange: (stationId: number | null) => void
}

const StationSelector: React.FC<Props> = ({
  stations,
  selectedStation,
  onStationChange,
}) => {
  const stationOptions: SelectOption[] = stations.map(station => ({
    value: station.id.toString(),
    label: station.name,
  }))

  const handleStationChange = (
    option: SelectOption | MultiValue<SelectOption>
  ) => {
    if (!Array.isArray(option)) {
      const singleOption = option as SelectOption | null
      if (singleOption && singleOption.value) {
        onStationChange(parseInt(singleOption.value, 10))
      } else {
        onStationChange(null)
      }
    }
  }

  const selectStyles = {
    control: (baseStyles: any) => ({
      ...baseStyles,
      minWidth: '360px',
      height: '4.8rem',
      padding: '0px 12px',
      fontSize: '1.6rem',
      fontWeight: '500',
      color: '#495057',
      cursor: 'pointer',
      backgroundColor: 'white',
      borderRadius: '4px',
      border: 'none',
    }),
    valueContainer: (baseStyles: any) => ({
      ...baseStyles,
      padding: '0',
    }),
    input: (baseStyles: any) => ({
      ...baseStyles,
      padding: '0',
      margin: '0',
      '& input': {
        boxShadow: 'none',
      },
    }),
  }

  return (
    <div className={styles.stationSelectContainer}>
      <Select
        options={stationOptions}
        onChange={handleStationChange}
        value={selectedStation}
        isMulti={false}
        placeholder={preMakingContent.stationSelectPlaceholder}
        styles={selectStyles}
      />
    </div>
  )
}

export default StationSelector
